<template>
  <div class="flex flex-nowrap items-center gap-2 divide-x divide-[#576166]">
    <template v-for="nav in navs">
      <RouterLink
        v-if="nav.route"
        :to="nav.route"
      >
        <div class="ml-2 flex flex-nowrap items-center justify-center gap-2 font-bold">
          <SvgIcon
            :name="nav.icon"
            size="14px"
          />
          <div class="text-[#D1D9E3]">
            {{ nav.label }}
          </div>
        </div>
      </RouterLink>
    </template>
    <div class="px-6 flex items-center">
      <div
        class="font-bold"
        @click.prevent="authStore.logout"
      >
        <RouterLink to="#">
          LOGOUT
        </RouterLink>
      </div>
    </div>
  </div>
</template>

<script setup>
import SvgIcon from '@/components/Icons/SvgIcon.vue'
import { useAuthStore } from "@/stores/auth"

const authStore = useAuthStore()
const navs = [
  {
    icon: 'deposits',
    label: '충전',
    route: {name: 'deposits'}
  },
  {
    icon: 'withdrawals',
    label: '환전',
    route: {name: 'withdrawals'}
  },
  {
    icon: 'questions',
    label: '고객센터',
    route: {name: 'questions'}
  },
  {
    icon: 'bets',
    label: '배팅내역',
    route: {name: 'bets', params: {category: 'pregame'}}
  },
  {
    icon: 'attendances',
    label: '출석체크',
    route: {name: 'attendances'}
  },
  {
    icon: 'exchanges',
    label: '포인트전환',
    route: {name: 'exchanges'}
  },
  {
    icon: 'events',
    label: '이벤트',
    route: {name: 'events'}
  },
  {
    icon: 'announcements',
    label: '공지',
    route: {name: 'announcements'}
  },
  {
    icon: 'threads',
    label: '게시판',
    route: {name: 'threads'}
  },
  {
    icon: 'consumables',
    label: '골드템샵',
    route: { name: 'consumables' },
  },
  {
    icon: 'messages',
    label: '쪽지함',
    route: { name: 'messages' },
  },
  {
    icon: 'lottery-wheel',
    label: '스핀룰렛',
    route: { name: 'lottery.wheel' }
  },
  {
    icon: 'coupons',
    label: '쿠폰',
    route: { name: 'coupons' }
  }
]
</script>